const hsaiQuizResultsContainer = document.querySelector('.the-content');
const breakdownLabelArray = document.querySelectorAll('.breakdown-label');


document.addEventListener('DOMContentLoaded', () => {
    console.log(calcArray);
    console.log(submissionArray['First Name']); 

    Object.entries(calcArray).forEach(([key,value]) => {
        breakdownLabelArray.forEach( (el) => {
            if(el.classList.contains(key) && value == 1){
                el.querySelector('p').textContent = "Gap";
                el.classList.add('red-tone');
            }
            else if(el.classList.contains(key) && value == 2){
                el.querySelector('p').textContent = "Partial";
                el.classList.add('blue-tone');
            }
            else if(el.classList.contains(key) && value == 3){
                el.querySelector('p').textContent = "Strong";
                el.classList.add('berry-tone');
            }
        });
    });



    // Need to asses the best way to fire the country code here, do we need it? This is just a warm lead...
    let getUserCountry = async() => {
        try{
            const response = await fetch('/wp-json/custom/v1/check-country');

            if (!response.ok){
                throw new Error('Http error' + response.status);
            }
            const data = await response.json(); 
            console.log('Country data:', data);

            return data;
        }
        catch (error){
            console.error('Error Fetching data: ', error); 
            return null;
        }
    }

    ChiliPiper.submit("insiderealestate", "boldtrail---homesearch-ai-quiz", {
        trigger: 'ThirdPartyForm', 
        lead: {
            "firstname": submissionArray['First Name'], // replace the value with the value for First Name
            "lastname": submissionArray['Last Name'], // replace the value with the value for Last Name
            "email": submissionArray['Email'], // replace the value with the value for Email
            "phone": submissionArray['Phone'], // replace the value with the value for Phone
            "role": submissionArray['Job Title'], // replace the value with the value for Which Best Describes You?
            "estimated_employee_count": submissionArray['Team Size'], // replace the value with the value for Number of Agents
            "company": submissionArray['Company'], // replace the value with the value for Company Name
            "utm_conversion_event_c": submissionArray['Capture_Method__c'], // replace the value with the value for Conversion Event
            "cta_type": submissionArray['CTA_Type__c'], // replace the value with the value for CTA Type
            "product_interest": submissionArray['Product Interest'], // replace the value with the value for Product Interest
            "utm_capture_method_c": submissionArray['Capture_Method__c'], // replace the value with the value for Capture Method
            "type": submissionArray['Type__c'], // replace the value with the value for Type
            "utm_cp_router_c": submissionArray['CP_Router__c'], // replace the value with the value for CP Router
            "leadsource": submissionArray['LeadSource'], // replace the value with the value for Lead Source
            "full_source": submissionArray['GA_Session_String__c'], // replace the value with the value for GA Session String
            "referral_source": submissionArray['Referral_Source__c'], // replace the value with the value for Referral Source
            "referral_campaign": submissionArray['Referral_Campaign__c'], // replace the value with the value for Referral Campaign
            "referral_medium": submissionArray['Referral_Medium__c'], // replace the value with the value for Referral Medium
            "campaign_content": submissionArray['Campaign_Content__c'], // replace the value with the value for Campaign Content
            "referral_keyword": submissionArray['Referral_Keyword__c'], // replace the value with the value for Referral Keyword
            "gclid": "", // replace the value with the value for GCLID
            "chili_reference_id": "", // replace the value with the value for Chili Reference ID
        }
    });
});